<rt-select
  [options]="selectOptions()"
  [hasSearch]="false"
  [hasInputTrigger]="true"
  [includeEmptyOption]="!required()"
  [formControl]="control()"
  margin-top-small-x
/>
